/**
 * @param {string} item
 * @param {number} i
 * @return {Object}
 */
export const transformItem = (item, i) => ({ id: i, value: item });

/**
 * Extracts colors from Cake bootstrap data
 * @param {string} groupName
 * @param {Object[]} colorGroups
 */
export const parseColorsFromCmsBootstrapFormat = (groupName, colorGroups) => {
    const colorsGroup = (colorGroups || []).find(({ name } = {}) => name === groupName);

    if (colorsGroup && colorsGroup.colors) {
        return colorsGroup.colors.map(transformItem);
    }

    return [];
};
